(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/chart.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"main-chart-wrapper\"> <canvas class=\"aspect-ratio-placeholder\" width=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth"), env.opts.autoescape);
output += "\" height=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight"), env.opts.autoescape);
output += "\"></canvas> ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"loading")) {
output += " ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../hmodules/components/h-charts/partials/charts-loader.njk", false, "../hmodules/components/h-charts/partials/chart.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
callback(null,t_3);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += " ";
});
}
else {
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"noData")) {
output += " <div class=\"no-data-container\"> </div> ";
;
}
else {
output += " <svg class=\"main_chart\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight"), env.opts.autoescape);
output += "\"> ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"chart_type") == "pie") {
output += " ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"data");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("dataGroup", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += " ";
if(runtime.memberLookup((t_8),"type") == "pies") {
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../hmodules/components/h-charts/partials/chart-pie.njk", false, "../hmodules/components/h-charts/partials/chart.njk", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
callback(null,t_9);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
callback(null,t_11);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
});
}
output += " ";
;
}
}
frame = frame.pop();
output += " ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"chart_type") == "donut") {
output += " ";
frame = frame.push();
var t_15 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"data");
if(t_15) {t_15 = runtime.fromIterator(t_15);
var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("dataGroup", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += " ";
if(runtime.memberLookup((t_16),"type") == "donuts") {
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../hmodules/components/h-charts/partials/chart-donut.njk", false, "../hmodules/components/h-charts/partials/chart.njk", false, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
callback(null,t_17);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
callback(null,t_19);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
});
}
output += " ";
;
}
}
frame = frame.pop();
output += " ";
;
}
else {
output += " ";
frame = frame.push();
var t_23 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"columns");
if(t_23) {t_23 = runtime.fromIterator(t_23);
var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("group", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += " ";
var t_25;
t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("groupIndex", t_25, true);
if(frame.topLevel) {
context.setVariable("groupIndex", t_25);
}
if(frame.topLevel) {
context.addExport("groupIndex", t_25);
}
output += " ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("../hmodules/components/h-charts/partials/chart-group.njk", false, "../hmodules/components/h-charts/partials/chart.njk", false, function(t_27,t_26) {
if(t_27) { cb(t_27); return; }
callback(null,t_26);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
callback(null,t_28);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += " ";
});
}
}
frame = frame.pop();
output += " ";
;
}
;
}
output += " </svg> ";
;
}
output += " ";
;
}
output += " </div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
